module.exports = __webpack_public_path__ + "img/k.e59833b3.png";